import PropTypes from 'prop-types'
import { Link, graphql, useStaticQuery } from 'gatsby'
import { Tags } from '@tryghost/helpers-gatsby'
import { readingTime as readingTimeHelper } from '@tryghost/helpers'
import { News } from './News'
import { render } from 'react-dom'

const HighlightedNews = ({src}) => {

    const data = useStaticQuery(graphql`query HighlightedNews {
  allGhostPost(
    sort: {published_at: DESC}
    limit: 3
    filter: {tags: {elemMatch: {name: {eq: "#highlightednews"}}}}
  ) {
    nodes {
      id
      title
      slug
      tags {
        name
        slug
      }
      feature_image
      html
    }
  }
}`)
   //console.log(data.allGhostPost.nodes)

    const items = []
    {data.allGhostPost.nodes.map((post, index) => {
        items.push(
            <article className="" key={index}>
                <div className="shadowN box-shadow">
                    <div className = "row_elementor align_items_center d-flex">
                        <div className="col-lg-4 pclr">
                            <div className="overflow">
                                <div className="featured-image" title={ post.title }>
                                <img width="340" height="" className="img-responsive lozad" src={ post.feature_image } alt={ post.title} loading="lazy"/>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8 highlighted">
                        <div className="tit">{ post.title }</div>
                        <div className = ""><div dangerouslySetInnerHTML={{ __html: post.html }} ></div></div>
                        </div>
                    </div>
                    
                    
                </div>
            </article>)
    })}

    return (
        <><div>
            {items}
        </div></>
    )

}

export default HighlightedNews
